import type { Seminar } from 'services/seminars/types'
import type { Props as BaseProps } from 'services/content/components/types/FindACourseModule'
import Link from 'content-components/_Primatives/Link'
import Loader from 'content-components/_Primatives/Loader'
import LocationTableCell from './LocationTableCell'
import DateTimeTableCell from './DateTimeTableCell'
import ButtonTableCell from './ButtonTableCell'
import Filter from './Filter'

import style from './style.scss'

type Props = BaseProps & {
  seminars: Seminar[]
  onChangeFilter: (field: string, value: string) => void
  isLoading: boolean
  params: Record<string, string>
  selectedCountry: string
  languageStrings: Record<
    string,
    { name: string; registerButtonText: string; soldOutButtonText: string }
  >
}

function FindACourse({
  titleText,
  // countryText,
  locationText,
  dateText,
  timeText,
  learnMoreText,
  courseMetaData,
  seminars,
  filters,
  onChangeFilter,
  selectedCountry,
  params,
  isLoading,
  noResultsFoundText,
  languageStrings,
}: Props) {
  return (
    <>
      <div className={style.filters}>
        {filters.map((filter) => (
          <Filter
            key={filter.field}
            onChange={onChangeFilter}
            selectedCountry={selectedCountry}
            selectedOption={params[filter.field]}
            {...filter}
          />
        ))}
      </div>
      <table className={style.table}>
        <thead className={style.tableHead}>
          <tr>
            <th className={style.tableHeadCell}>{titleText}</th>
            <th className={style.tableHeadCell}>Language</th>
            <th className={style.tableHeadCell}>{locationText}</th>
            <th className={style.tableHeadCell}>
              {dateText}/{timeText}
            </th>
            <th className={style.tableHeadCell}></th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={4}>
                <Loader small />
              </td>
            </tr>
          ) : (
            seminars.map((seminar) => (
              <tr className={style.tableRow} key={seminar.id}>
                <td className={style.tableCell}>
                  <div className={style.text}>
                    {courseMetaData[seminar.metaType].title}
                  </div>
                  <Link className={style.link} url={seminar.detailsPageUrl}>
                    {learnMoreText}
                  </Link>
                </td>
                <td className={style.tableCell}>
                  <div>{languageStrings[seminar.language]?.name}</div>
                  {seminar.translations.map((lang) => (
                    <div key={lang}>{languageStrings[lang]?.name}</div>
                  ))}
                </td>
                <LocationTableCell
                  className={style.tableCell}
                  seminar={seminar}
                />
                <DateTimeTableCell
                  className={style.tableCell}
                  seminar={seminar}
                />
                <ButtonTableCell
                  className={style.tableCell}
                  seminar={seminar}
                  registerButtonText={
                    languageStrings[seminar.language]?.registerButtonText
                  }
                  soldOutButtonText={
                    languageStrings[seminar.language]?.soldOutButtonText
                  }
                />
              </tr>
            ))
          )}
          {!isLoading && seminars.length === 0 && (
            <tr className={style.noResultsFound}>
              <td colSpan={6}>{noResultsFoundText}</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  )
}

export default FindACourse
